import decimalsMask from './decimalsMask';

export const getMapping = (mappings, name) => (
  mappings && name ? mappings[name] : undefined
);

export const getCsvName = (mappings, name) => (
  getMapping(mappings, name)?.csvName
);

export const getUnit = (mappings, name, fallback = '') => {
  const configuredUnit = getMapping(mappings, name)?.unit;
  if (configuredUnit && configuredUnit !== '') {
    return configuredUnit;
  }
  return fallback;
};

export const resolveUnit = (mappings, preferredKeys, defaultUnit = '') => {
  const keys = Array.isArray(preferredKeys) ? preferredKeys : [preferredKeys];
  for (let index = 0; index < keys.length; index += 1) {
    const candidateUnit = getUnit(mappings, keys[index]);
    if (candidateUnit) {
      return candidateUnit;
    }
  }
  return defaultUnit;
};

export const getPrecisionForUnit = (unitName, fallbackPrecision = 2) => {
  if (!unitName) {
    return fallbackPrecision;
  }
  return decimalsMask[unitName] ?? fallbackPrecision;
};
